"use strict";

var _interopRequireDefault = require("/www/wwwroot/python/front/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/python/front/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    }
  }),
  data: function data() {
    return {
      search: '',
      // 顶部搜索框form数据
      formInline: {
        keyword: '' //搜索关键词
      },
      dialogVisibleshop: false,
      // 控制修改商家信息form
      // 商家基础信息
      shopInfo: {},
      // 修改商家基础信息form
      shopform: {
        company_name: '',
        address: '',
        scc: '',
        product_name: '',
        email: '',
        status: '',
        alipay: '',
        sealId: '',
        aa_id: '',
        bb_id: '',
        cc_id: '',
        mobile: '',
        id: ''
      }
    };
  },
  methods: {
    handleRefresh: function handleRefresh() {
      // 通知子组件重新发送请求
      this.$refs.target.getList();
    },
    handleClick: function handleClick(item) {
      this.$router.push({
        name: 'shopDetail',
        query: {
          id: item.id
        }
      });
    },
    handleFilter: function handleFilter(e) {
      // this.$refs.target.handleFilter()
      this.listLoading = true;
      this.formInline.keyword = e.target.value;
      // 调用子组件的goSearch方法
      this.$refs.target.goSearch(this.formInline.keyword);
    },
    // 获取当前商家的信息
    editClick: function editClick(data) {
      var _this = this;
      this.shopform.id = data.id;
      (0, _request.default)({
        url: "/system/customer/getInfoAll/",
        method: 'get',
        params: {
          shop_id: data.id
        }
      }).then(function (res) {
        _this.shopInfo = res.data;
        _this.shopform.company_name = res.data.company_name;
        _this.shopform.address = res.data.address;
        _this.shopform.scc = res.data.scc;
        _this.shopform.product_name = res.data.product_name;
        _this.shopform.email = res.data.email;
        _this.shopform.status = res.data.status;
        _this.shopform.alipay = res.data.customer.alipay;
        _this.shopform.sealId = res.data.customer.sealId;
        _this.shopform.mobile = res.data.mobile;
        _this.dialogVisibleshop = true;
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 修改商家信息保存
    onSubmitShop: function onSubmitShop() {
      var _this2 = this;
      // 提交数据给后端
      (0, _request.default)({
        url: "/system/customer/updateInfo/",
        method: 'put',
        data: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
          alipay: this.shopform.alipay,
          company_name: this.shopform.company_name,
          address: this.shopform.address,
          scc: this.shopform.scc,
          product_name: this.shopform.product_name,
          email: this.shopform.email,
          status: this.shopform.status
        }, "alipay", this.shopform.alipay), "sealId", this.shopform.sealId), "aa_id", this.shopform.aa_id), "bb_id", this.shopform.bb_id), "cc_id", this.shopform.cc_id), "shop_id", this.shopform.id), "mobile", this.shopform.mobile)
      }).then(function (response) {
        if (response.code == 200) {
          _this2.dialogVisibleshop = false;
          _this2.$message({
            type: 'success',
            message: '修改成功,刷新页面查看最新数据'
          });
          _this2.shopform = {
            company_name: '',
            address: '',
            scc: '',
            product_name: '',
            email: '',
            status: '',
            alipay: '',
            sealId: '',
            aa_id: '',
            bb_id: '',
            cc_id: '',
            mobile: '',
            id: ''
          };
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};